<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="col-md-12 pt-0 pb-0 text-center m-1">
        <v-btn class="btn-edit m-2" @click="handleTypeEdit('INSTRUCTION')">
          <i class="fas fa-edit mr-2 text-twenty"></i>EDITAR INSTRUÇÃO
        </v-btn>
        <v-btn class="v-warning m-2" @click="handleTypeEdit('MEDICINE')">
          <i class="fas fa-capsules mr-2 text-twenty"></i>
          EDITAR MEDICAMENTO
        </v-btn>
        <ErrorsMessages :errors="errors" />
        <div v-if="datesCheck && datesCheck.length > 0" class="border">
          <h6 class="title-pages text-fifteen text-center border-bottom">
            DATA(S) QUE O MEDICAMENTO ESTÁ APENAS SEPARADO
          </h6>
          <div v-for="(date, key) in datesCheck" :key="key">
            <div class="d-flex align-items-center justify-content-center">
              <b class="mr-2">{{ formatDate(date, false) }}</b>
              <v-btn
                small
                @click="handleCheckDate(date)"
                class="mt-1 mb-1 v-primary"
              >
                <i class="fas fa-arrow-right mr-2"></i>
                ACESSAR
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div v-show="edit == 'INSTRUCTION'">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h6 class="text-fourteen">INSTRUÇÃO</h6>
            <ChromeSpeechToTextTextarea
              rows="4"
              max-rows="10"
              v-model="instruction"
            />
          </div>
          <div class="col-md-12">
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="col-md-12 text-right">
            <v-btn
              :disabled="loadingUpdate"
              @click="updateInstruction"
              class="btn-acess"
            >
              <i class="mr-1 fas fa-check"></i>
              {{ loadingUpdate ? "CARREGANDO" : "SALVAR INSTRUÇÃO" }}
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="edit == 'MEDICINE'">
        <div v-show="step == 1">
          <div class="row">
            <div class="col-md-12">
              <label>NOME COMERCIAL</label>
              <input disabled v-model="name" type="text" class="form-control" />
            </div>
            <div class="col-md-12">
              <label>PRINCÍPIO ATIVO</label>
              <input
                disabled
                v-model="active_ingredient"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label>UNIDADE DE MEDIDA</label>
              <select
                disabled
                v-model="unit_of_measurement_id"
                class="form-control"
              >
                <option value>SELECIONE...</option>
                <option
                  v-for="value in unitOfMeasurements"
                  :key="value.id"
                  :value="value.id"
                  :ref="`unit_of_measurement_${value.id}`"
                  :data-name="value.name"
                  :data-v="value.value"
                  :data-abbreviation="value.abbreviation"
                >
                  {{ value.name }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <label>UNIDADE DE ADMINISTRAÇÃO</label>
              <input
                disabled
                v-model="unit_of_measurement_abbreviation"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-md-12">
              <label>VIA DE ADMINISTRAÇÃO</label>
              <select v-model="route_of_administration_id" class="form-control">
                <option value>SELECIONE...</option>
                <option
                  v-for="value in routeOfAdministration"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ value.name }}
                </option>
              </select>
            </div>
            <div class="col-md-12">
              <ErrorsMessages :errors="errors" />
            </div>
          </div>
        </div>
        <div v-show="step == 2">
          <div class="row">
            <div
              class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 d-flex justify-content-center"
            >
              <i class="fas fa-capsules fa-3x color-blue"></i>
            </div>
            <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-12 pt-1">
              <h6 class="mb-0 check-text-center">MEDICAMENTO: {{ name }}</h6>
              <h6 class="mb-0 worksansr check-text-center text-fourteen">
                PRINCÍPIO ATIVO: {{ active_ingredient }}
              </h6>
              <h6 class="mb-0 worksansr check-text-center text-fourteen">
                UNIDADE DE MEDIDA:
                {{ unit_of_measurement_name }}
              </h6>
              <h6 class="mb-0 worksansr check-text-center text-fourteen">
                UNIDADE DE ADMINISTRAÇÃO:
                {{ unit_of_measurement_abbreviation }}
              </h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <label>FREQUÊNCIA</label>
              <select
                @change="handleChangeFrequency($event.target.value)"
                v-model="frequency"
                class="form-control"
              >
                <option value="DIARIO">DIÁRIO</option>
                <option value="SEMANAL">SEMANAL</option>
                <option
                  v-if="group_prescription_medicine.type == 'LONGO_PRAZO'"
                  value="MENSAL"
                >
                  MENSAL
                </option>
                <option
                  v-if="group_prescription_medicine.type == 'LONGO_PRAZO'"
                  value="ANUAL"
                >
                  ANUAL
                </option>
                <option
                  v-if="group_prescription_medicine.type == 'NORMAL'"
                  value="EVENTUAL"
                >
                  EVENTUAL
                </option>
              </select>
            </div>
            <div
              v-if="show_all_frequency || show_quantity_of_times_a_day"
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
            >
              <label>QUANTIDADE DIÁRIA</label>
              <select
                @change="
                  handleChangeMedicineAmountOfTimesId($event.target.value)
                "
                v-model="medicine_amount_of_times_id"
                class="form-control"
              >
                <option value>SELECIONE...</option>
                <option
                  v-for="value in amountOfTimes"
                  :key="value.id"
                  :value="value.id"
                  :ref="`medicine_amount_of_times_${value.id}`"
                  :data-type="value.type"
                >
                  {{ value.name }}
                </option>
              </select>
            </div>
            <div
              v-if="show_all_frequency"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-center"
            >
              <label class="mb-0 day-width">A CADA</label>
              <input v-model="every" type="text" class="form-control" />
              <label class="mb-0 day-width pl-3"
                >{{ medicine_frequency_abbreviation }}(S)</label
              >
            </div>
            <div v-if="show_weekly" class="p-2">
              <v-btn
                :class="['v-no-border-radius', DOM ? 'v-primary' : '']"
                @click="DOM = !DOM"
                >DOM</v-btn
              >
              <v-btn
                :class="['v-no-border-radius', SEG ? 'v-primary' : '']"
                @click="SEG = !SEG"
                >SEG</v-btn
              >
              <v-btn
                :class="['v-no-border-radius', TER ? 'v-primary' : '']"
                @click="TER = !TER"
                >TER</v-btn
              >
              <v-btn
                :class="['v-no-border-radius', QUA ? 'v-primary' : '']"
                @click="QUA = !QUA"
                >QUA</v-btn
              >
              <v-btn
                :class="['v-no-border-radius', QUI ? 'v-primary' : '']"
                @click="QUI = !QUI"
                >QUI</v-btn
              >
              <v-btn
                :class="['v-no-border-radius', SEX ? 'v-primary' : '']"
                @click="SEX = !SEX"
                >SEX</v-btn
              >
              <v-btn
                :class="['v-no-border-radius', SAB ? 'v-primary' : '']"
                @click="SAB = !SAB"
                >SAB</v-btn
              >
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
              v-if="show_shifts"
            >
              <div class="row">
                <div
                  class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
                >
                  <vs-checkbox v-model="dawn">MADRUGADA</vs-checkbox>
                </div>
                <div
                  v-if="
                    unit_of_measurement_value == 'ML' ||
                    unit_of_measurement_value == 'UI'
                  "
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                >
                  <label>UI/ML/GOTAS</label>
                  <select
                    @change="
                      handleChangeMlOrDropsDawnQuantity($event.target.value)
                    "
                    v-model="ml_or_drops_dawn_quantity"
                    class="form-control"
                  >
                    <option value="UI">UI</option>
                    <option value="ML">ML</option>
                    <option value="GOTAS">GOTAS</option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label>
                    {{ unit_of_measurement_name
                    }}{{
                      unit_of_measurement_name == "ML" ||
                      unit_of_measurement_name == "UI/ML"
                        ? "/GOTAS"
                        : ""
                    }}
                  </label>
                  <input
                    v-model="dawn_quantity"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div
                  class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
                >
                  <vs-checkbox v-model="morning">MANHÃ</vs-checkbox>
                </div>
                <div
                  v-if="
                    unit_of_measurement_value == 'ML' ||
                    unit_of_measurement_value == 'UI'
                  "
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                >
                  <label>UI/ML/GOTAS</label>
                  <select
                    @change="
                      handleChangeMlOrDropsMorningQuantity($event.target.value)
                    "
                    v-model="ml_or_drops_morning_quantity"
                    class="form-control"
                  >
                    <option value="UI">UI</option>
                    <option value="ML">ML</option>
                    <option value="GOTAS">GOTAS</option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label>
                    {{ unit_of_measurement_name
                    }}{{
                      unit_of_measurement_name == "ML" ||
                      unit_of_measurement_name == "UI/ML"
                        ? "/GOTAS"
                        : ""
                    }}
                  </label>
                  <input
                    v-model="morning_quantity"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div
                  class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
                >
                  <vs-checkbox v-model="afternoon">TARDE</vs-checkbox>
                </div>
                <div
                  v-if="
                    unit_of_measurement_value == 'ML' ||
                    unit_of_measurement_value == 'UI'
                  "
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                >
                  <label>UI/ML/GOTAS</label>
                  <select
                    @change="
                      handleChangeMlOrDropsAfternoonQuantity(
                        $event.target.value
                      )
                    "
                    v-model="ml_or_drops_afternoon_quantity"
                    class="form-control"
                  >
                    <option value="UI">UI</option>
                    <option value="ML">ML</option>
                    <option value="GOTAS">GOTAS</option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label>
                    {{ unit_of_measurement_name
                    }}{{
                      unit_of_measurement_name == "ML" ||
                      unit_of_measurement_name == "UI/ML"
                        ? "/GOTAS"
                        : ""
                    }}
                  </label>
                  <input
                    v-model="afternoon_quantity"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div
                  class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
                >
                  <vs-checkbox v-model="night">NOITE</vs-checkbox>
                </div>
                <div
                  v-if="
                    unit_of_measurement_value == 'ML' ||
                    unit_of_measurement_value == 'UI'
                  "
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                >
                  <label>UI/ML/GOTAS</label>
                  <select
                    @change="
                      handleChangeMlOrDropsNightQuantity($event.target.value)
                    "
                    v-model="ml_or_drops_night_quantity"
                    class="form-control"
                  >
                    <option value="UI">UI</option>
                    <option value="ML">ML</option>
                    <option value="GOTAS">GOTAS</option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label>
                    {{ unit_of_measurement_name
                    }}{{
                      unit_of_measurement_name == "ML" ||
                      unit_of_measurement_name == "UI/ML"
                        ? "/GOTAS"
                        : ""
                    }}
                  </label>
                  <input
                    v-model="night_quantity"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div
                  class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
                >
                  <vs-checkbox v-model="shift_5">5º</vs-checkbox>
                </div>
                <div
                  v-if="
                    unit_of_measurement_value == 'ML' ||
                    unit_of_measurement_value == 'UI'
                  "
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                >
                  <label>UI/ML/GOTAS</label>
                  <select
                    @change="
                      handleChangeMlOrDropsshift_5Quantity($event.target.value)
                    "
                    v-model="ml_or_drops_shift_5_quantity"
                    class="form-control"
                  >
                    <option value="UI">UI</option>
                    <option value="ML">ML</option>
                    <option value="GOTAS">GOTAS</option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label>
                    {{ unit_of_measurement_name
                    }}{{
                      unit_of_measurement_name == "ML" ||
                      unit_of_measurement_name == "UI/ML"
                        ? "/GOTAS"
                        : ""
                    }}
                  </label>
                  <input
                    v-model="shift_5_quantity"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div
                  class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
                >
                  <vs-checkbox v-model="shift_6">6º</vs-checkbox>
                </div>
                <div
                  v-if="
                    unit_of_measurement_value == 'ML' ||
                    unit_of_measurement_value == 'UI'
                  "
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                >
                  <label>UI/ML/GOTAS</label>
                  <select
                    @change="
                      handleChangeMlOrDropsshift_6Quantity($event.target.value)
                    "
                    v-model="ml_or_drops_shift_6_quantity"
                    class="form-control"
                  >
                    <option value="UI">UI</option>
                    <option value="ML">ML</option>
                    <option value="GOTAS">GOTAS</option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label>
                    {{ unit_of_measurement_name
                    }}{{
                      unit_of_measurement_name == "ML" ||
                      unit_of_measurement_name == "UI/ML"
                        ? "/GOTAS"
                        : ""
                    }}
                  </label>
                  <input
                    v-model="shift_6_quantity"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div
                  class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
                >
                  <vs-checkbox v-model="shift_7">7º</vs-checkbox>
                </div>
                <div
                  v-if="
                    unit_of_measurement_value == 'ML' ||
                    unit_of_measurement_value == 'UI'
                  "
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                >
                  <label>UI/ML/GOTAS</label>
                  <select
                    @change="
                      handleChangeMlOrDropsshift_7Quantity($event.target.value)
                    "
                    v-model="ml_or_drops_shift_7_quantity"
                    class="form-control"
                  >
                    <option value="UI">UI</option>
                    <option value="ML">ML</option>
                    <option value="GOTAS">GOTAS</option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label>
                    {{ unit_of_measurement_name
                    }}{{
                      unit_of_measurement_name == "ML" ||
                      unit_of_measurement_name == "UI/ML"
                        ? "/GOTAS"
                        : ""
                    }}
                  </label>
                  <input
                    v-model="shift_7_quantity"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div
                  class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
                >
                  <vs-checkbox v-model="shift_8">8º</vs-checkbox>
                </div>
                <div
                  v-if="
                    unit_of_measurement_value == 'ML' ||
                    unit_of_measurement_value == 'UI'
                  "
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                >
                  <label>UI/ML/GOTAS</label>
                  <select
                    @change="
                      handleChangeMlOrDropsshift_8Quantity($event.target.value)
                    "
                    v-model="ml_or_drops_shift_8_quantity"
                    class="form-control"
                  >
                    <option value="UI">UI</option>
                    <option value="ML">ML</option>
                    <option value="GOTAS">GOTAS</option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label>
                    {{ unit_of_measurement_name
                    }}{{
                      unit_of_measurement_name == "ML" ||
                      unit_of_measurement_name == "UI/ML"
                        ? "/GOTAS"
                        : ""
                    }}
                  </label>
                  <input
                    v-model="shift_8_quantity"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="
                show_quantity &&
                (unit_of_measurement_value == 'ML' ||
                  unit_of_measurement_value == 'UI')
              "
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
            >
              <label>UI/ML/GOTAS</label>
              <select
                @change="handleChangeMlOrDrops($event.target.value)"
                v-model="ml_or_drops"
                class="form-control"
              >
                <option value="UI">UI</option>
                <option value="ML">ML</option>
                <option value="GOTAS">GOTAS</option>
              </select>
            </div>
            <div
              v-if="show_quantity"
              :class="[
                unit_of_measurement_value == 'ML' ||
                unit_of_measurement_value == 'UI'
                  ? 'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'
                  : 'col-md-12',
              ]"
            >
              <label>
                {{ unit_of_measurement_name
                }}{{
                  unit_of_measurement_name == "ML" ||
                  unit_of_measurement_name == "UI/ML"
                    ? "/GOTAS"
                    : ""
                }}
              </label>
              <input v-model="quantity" type="text" class="form-control" />
            </div>
            <div class="col-md-12">
              <ErrorsMessages :errors="errors" />
            </div>
          </div>
        </div>
        <div v-show="step == 2.5">
          <div class="row">
            <div
              class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 d-flex justify-content-center"
            >
              <i class="fas fa-capsules fa-3x color-blue"></i>
            </div>
            <div class="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12">
              <h6 class="mb-0">
                MEDICAMENTO:
                {{ name }}
              </h6>
              <h6 class="mb-0 text-two">
                UNIDADE DE MEDIDA:
                {{ unit_of_measurement_name }}
              </h6>
              <h6 class="mb-0 text-two">
                UNIDADE DE ADMINISTRAÇÃO:
                {{ unit_of_measurement_abbreviation }}
              </h6>
            </div>
            <div class="col-md-6">
              <label>REPETIR DOSAGEM</label>
              <div class="row">
                <div class="col-md-10">
                  <vs-slider :min="0" :max="30" v-model="repeat_dosage" />
                </div>
                <div class="col-md-2">
                  <div class="d-flex justify-content-center align-items-center">
                    <h3 class="c-primary mr-1">{{ repeat_dosage }}</h3>
                    {{
                      repeat_dosage == 0 || repeat_dosage == 1 ? "DIA" : "DIAS"
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label>REPETIR APÓS</label>
              <select v-model="repeat_after" class="form-control">
                <option value="NAO">NÃO REPETIR</option>
                <option v-for="repeat of 3" :key="repeat" :value="repeat">
                  {{ repeat }}
                  {{ repeat == 1 ? "SEMANA" : `${repeat_after_type}S` }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label>QUANTAS VEZES</label>
              <select v-model="how_many_times" class="form-control">
                <option v-for="repeat of 3" :key="repeat" :value="repeat">
                  {{ repeat }}
                  {{ repeat == 1 ? "VEZ" : "VEZES" }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div v-show="step == 3">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div
                  class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 d-flex justify-content-center"
                >
                  <i class="fas fa-capsules fa-3x color-blue"></i>
                </div>
                <div
                  class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-12 pt-1"
                >
                  <h6 class="mb-0 check-text-center">
                    MEDICAMENTO:
                    {{ name }}
                  </h6>
                  <h6 class="mb-0 text-fourteen check-text-center worksansr">
                    PRINCÍPIO ATIVO:
                    {{ active_ingredient }}
                  </h6>
                  <h6 class="text-fourteen mb-0 check-text-center worksansr">
                    UNIDADE DE MEDIDA:
                    {{ unit_of_measurement_name }}
                  </h6>
                  <h6 class="mb-0 text-fourteen check-text-center worksansr">
                    UNIDADE DE ADMINISTRAÇÃO:
                    {{ unit_of_measurement_abbreviation }}
                  </h6>
                </div>
              </div>
            </div>
            <div
              v-if="!show_instruction"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            >
              <h6 class="text-fourteen">DURAÇÃO</h6>
              <vs-radio
                @change="handleChangeDuration($event.target.value)"
                v-model="duration"
                vs-value="CONTINUO"
                >CONTÍNUO</vs-radio
              >
              <vs-radio
                @change="handleChangeDuration($event.target.value)"
                v-if="show_during_a_period"
                v-model="duration"
                vs-value="DURANTE_UM_PERIODO"
                >DURANTE UM PERÍODO</vs-radio
              >
              <vs-radio
                @change="handleChangeDuration($event.target.value)"
                v-model="duration"
                vs-value="ATE_A_DATA"
                >ATÉ A DATA</vs-radio
              >
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                v-if="
                  (!show_instruction && show_start_date) ||
                  (!show_instruction && show_end_date) ||
                  (!show_instruction && show_duration_time)
                "
              >
                <div v-if="duration != 'CONTINUO'" class="row v-clean">
                  <div
                    v-if="!show_instruction && show_start_date"
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2"
                  >
                    <h6 class="text-fourteen">DATA DE INÍCIO</h6>
                    <input
                      v-model="start_date"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div
                    v-if="!show_instruction && show_end_date"
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2"
                  >
                    <h6 class="text-fourteen">DATA DE TÉRMINO</h6>
                    <input
                      v-model="end_date"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div
                    v-if="!show_instruction && show_duration_time"
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-9 col-12 pl-5 pt-3"
                  >
                    <h6 class="text-fourteen">TEMPO DE DURAÇÃO</h6>
                    <vs-slider :min="1" :max="30" v-model="duration_time" />
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <h6 class="c-primary">{{ duration_time }} DIA(S)</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="duration == 'CONTINUO'"
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2 pt-0 pl-3"
            >
              <h6 class="text-fourteen">INICIAR MEDICAMENTO</h6>
              <input v-model="init" type="date" class="form-control" />
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pl-3"
            >
              <h6 class="text-fourteen">INSTRUÇÃO</h6>
              <ChromeSpeechToTextTextarea
                rows="4"
                max-rows="10"
                v-model="instruction"
              />
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
            >
              <ErrorsMessages :errors="errors" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 d-flex justify-content-between">
            <v-btn
              :disabled="step == 1"
              @click="handlePrevStep"
              class="btn-return"
            >
              <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
            </v-btn>
            <v-btn
              v-if="step != 3"
              :disabled="loadingUpdate"
              @click="handleNextStep"
              class="btn-acess"
            >
              AVANÇAR
              <i class="fas fa-arrow-right ml-2 text-twenty"></i>
            </v-btn>
            <v-btn
              v-if="step == 3"
              :disabled="loadingUpdate"
              @click="handleNextStep"
              :class="[
                group_prescription_medicine.status == 'PENDENTE'
                  ? 'btn-save'
                  : 'btn-notcertified',
              ]"
            >
              <span v-if="loading">CARREGANDO</span>
              <span
                v-if="
                  !loading && group_prescription_medicine.status == 'PENDENTE'
                "
              >
                SALVAR
                <i class="fas fa-save ml-2 text-twenty"></i>
              </span>
              <span
                v-if="
                  !loading && group_prescription_medicine.status == 'FINALIZADO'
                "
              >
                <i class="fas fa-check mr-2 text-twenty"></i>
                FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA
              </span>
            </v-btn>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import ChromeSpeechToTextTextarea from "../../../templates/Components/ChromeSpeechToTextTextarea";

import api from "../../../services/api";

import { userData } from "../../../lib/functions";

import toast from "../../../lib/ToastNotification";

import { formatDateToUs, formatDate } from "../../../lib/format";

export default {
  name: "Medicine",

  components: {
    ErrorsMessages,
    ChromeSpeechToTextTextarea,
  },

  data() {
    return {
      step: 1,
      edit: "",
      medicine: null,
      medicine_type: null,
      id: "",
      user_id: "",
      resident_id: "",
      rest_home_id: "",
      unit_of_measurement_id: "",
      route_of_administration_id: "",
      name: "",
      active_ingredient: "",
      unit_of_measurement_name: "",
      unit_of_measurement_value: "",
      unit_of_measurement_abbreviation: "",
      medicine_amount_of_times_id: "",
      unitOfMeasurements: [],
      routeOfAdministration: [],
      medicineAmountOfTimes: [],
      amountOfTimes: [],
      medicine_frequency_abbreviation: "DIA",
      errors: [],
      loading: false,
      loadingUpdate: false,
      show_all_frequency: true,
      show_weekly: false,
      type_medicine_amount_of_times_id: "",
      show_shifts: false,
      frequency: "DIARIO",
      every: "",
      morning: false,
      morning_quantity: "",
      tmp_morning_quantity: "",
      ui_morning_quantity: null,
      drops_morning_quantity: null,
      afternoon: false,
      afternoon_quantity: "",
      tmp_afternoon_quantity: "",
      ui_afternoon_quantity: null,
      drops_afternoon_quantity: null,
      night: false,
      night_quantity: "",
      tmp_night_quantity: "",
      ui_night_quantity: null,
      drops_night_quantity: null,
      dawn: false,
      dawn_quantity: "",
      tmp_dawn_quantity: "",
      ui_dawn_quantity: null,
      drops_dawn_quantity: null,
      shift_5: false,
      shift_5_quantity: "",
      tmp_shift_5_quantity: "",
      ui_shift_5_quantity: null,
      drops_shift_5_quantity: null,
      shift_6: false,
      shift_6_quantity: "",
      tmp_shift_6_quantity: "",
      ui_shift_6_quantity: null,
      drops_shift_6_quantity: null,
      shift_7: false,
      shift_7_quantity: "",
      tmp_shift_7_quantity: "",
      ui_shift_7_quantity: null,
      drops_shift_7_quantity: null,
      shift_8: false,
      shift_8_quantity: "",
      tmp_shift_8_quantity: "",
      ui_shift_8_quantity: null,
      drops_shift_8_quantity: null,
      DOM: false,
      SEG: false,
      TER: false,
      QUA: false,
      QUI: false,
      SEX: false,
      SAB: false,
      quantity: "",
      tmp_quantity: "",
      ui_quantity: null,
      drops_quantity: null,
      show_quantity: true,
      duration: "CONTINUO",
      show_during_a_period: false,
      instruction: "",
      show_instruction: false,
      start_date: "",
      show_start_date: false,
      end_date: "",
      show_end_date: false,
      duration_time: 1,
      show_duration_time: false,
      show_quantity_of_times_a_day: false,
      ml_or_drops: null,
      ml_or_drops_morning_quantity: null,
      ml_or_drops_afternoon_quantity: null,
      ml_or_drops_night_quantity: null,
      ml_or_drops_dawn_quantity: null,
      ml_or_drops_shift_5_quantity: null,
      ml_or_drops_shift_6_quantity: null,
      ml_or_drops_shift_7_quantity: null,
      ml_or_drops_shift_8_quantity: null,
      repeat_after_type: "MES",
      repeat_dosage: 0,
      repeat_after: "NAO",
      how_many_times: 1,
      init: "",

      datesCheck: [],
    };
  },

  props: {
    prescription_medicine: { type: Object },
    group_prescription_medicine: { type: Object },
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDateToUs,
    formatDate,

    handleTypeEdit(edit) {
      this.edit = "";
      this.errors = [];
      if (edit == "MEDICINE") {
        this.isValidToUpdate();
      } else {
        this.edit = edit;
      }
    },

    handlePrevStep() {
      const { step, group_prescription_medicine, frequency } = this;

      let SEMANAL = "SEMANAL";

      if (step == 1) {
        return;
      }

      if (group_prescription_medicine.type == "NORMAL") {
        this.step = step - 1;
      } else {
        if (step == 3) {
          if (frequency == SEMANAL) {
            this.step = step - 1;
          } else {
            this.step = 2.5;
          }
        } else if (step == 2.5) {
          this.step = 2;
        } else {
          this.step = step - 1;
        }
      }
      // this.step = step - 1;
    },

    handleNextStep() {
      this.errors = [];

      let { step, group_prescription_medicine } = this;

      if (step == 1) {
        let { route_of_administration_id } = this;

        if (!String(route_of_administration_id).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe via de admnistração",
          });
        }

        if (this.errors.length > 0) {
          return;
        }

        this.step = step + 1;
      }

      if (step == 2) {
        let {
          frequency,
          medicine_amount_of_times_id,
          medicine_frequency_abbreviation,
          every,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning,
          afternoon,
          night,
          dawn,
          shift_5,
          shift_6,
          shift_7,
          shift_8,
          type_medicine_amount_of_times_id,
        } = this;

        let DIARIO = "DIARIO";
        let SEMANAL = "SEMANAL";
        // let MENSAL = "MENSAL";
        // let ANUAL = "ANUAL";
        let EVENTUAL = "EVENTUAL";

        if (!String(frequency).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe frequência",
          });
        }

        if (!String(medicine_amount_of_times_id).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe quantidade diária",
          });
        }

        if (frequency != EVENTUAL) {
          if (frequency == SEMANAL) {
            if (!DOM && !SEG && !TER && !QUA && !QUI && !SEX && !SAB) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe ao menos um dia da semana",
              });
            }
          }

          if (type_medicine_amount_of_times_id == "SHIFTS") {
            if (
              !morning &&
              !afternoon &&
              !night &&
              !dawn &&
              !shift_5 &&
              !shift_6 &&
              !shift_7 &&
              !shift_8
            ) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe ao menos um turno",
              });
            }
          }

          if (type_medicine_amount_of_times_id == "DAY") {
            if (!String(every).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: `Informe a cada ${medicine_frequency_abbreviation}`,
              });
            }
          }
        }

        if (this.errors.length > 0) {
          return;
        }

        if (frequency == EVENTUAL) {
          this.show_instruction = true;
        } else {
          this.show_instruction = false;
        }

        if (frequency == DIARIO) {
          this.show_during_a_period = true;
        } else {
          this.show_during_a_period = false;
        }

        if (group_prescription_medicine.type == "NORMAL") {
          this.step = step + 1;
        } else {
          if (frequency == SEMANAL) {
            this.step = step + 1;
          } else {
            this.step = 2.5;
          }
        }
        // this.step = step + 1;
      }

      if (step == 2.5) {
        this.step = 3;
      }

      if (step == 3) {
        let {
          frequency,
          duration,
          instruction,
          start_date,
          end_date,
          duration_time,
          init,
        } = this;

        // let DIARIO = "DIARIO";
        // let SEMANAL = "SEMANAL";
        // let MENSAL = "MENSAL";
        // let ANUAL = "ANUAL";
        let EVENTUAL = "EVENTUAL";

        const ATE_A_DATA = "ATE_A_DATA";
        const DURANTE_UM_PERIODO = "DURANTE_UM_PERIODO";

        if (duration == ATE_A_DATA) {
          if (frequency != EVENTUAL) {
            if (!String(start_date).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe a data de início",
              });
            }
          }

          if (!String(end_date).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe data de término",
            });
          }
        }

        if (duration == DURANTE_UM_PERIODO) {
          if (frequency != EVENTUAL) {
            if (!String(start_date).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe a data de início",
              });
            }
          }

          if (!String(duration_time).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe tempo de duração",
            });
          }
        }

        if (frequency == EVENTUAL) {
          if (!String(instruction).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe instrução",
            });
          }
        }

        if (!init && duration == "CONTINUO") {
          this.errors.push({
            id: this.errors.length,
            message: "Informe a data que o medicamento irá iniciar",
          });
        }

        if (this.errors.length > 0) {
          return;
        }

        this.update();
      }
    },

    handleChangeMedicineAmountOfTimesId(value) {
      this.show_quantity = true;
      this.show_shifts = false;
      this.medicine_amount_of_times_abbreviation = "";

      const SHIFTS = "SHIFTS";

      if (value) {
        let { type } =
          this.$refs[`medicine_amount_of_times_${value}`][0].dataset;

        this.type_medicine_amount_of_times_id = type;

        if (type == SHIFTS) {
          this.show_quantity = false;
          this.show_shifts = true;
        }
      }
    },

    handleChangeFrequency(value) {
      const { medicineAmountOfTimes } = this;

      this.show_all_frequency = true;
      this.show_weekly = false;
      this.show_duration_time = false;
      this.show_quantity = true;
      this.show_quantity_of_times_a_day = false;
      this.duration = "CONTINUO";
      this.amountOfTimes = medicineAmountOfTimes;

      this.DOM = false;
      this.SEG = false;
      this.TER = false;
      this.QUA = false;
      this.QUI = false;
      this.SEX = false;
      this.SAB = false;

      let medicine_frequency_abbreviation = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      //   const DIARIO = "DIARIO";
      const SEMANAL = "SEMANAL";
      //   const MENSAL = "MENSAL";
      //   const ANUAL = "ANUAL";
      const EVENTUAL = "EVENTUAL";

      if (value == EVENTUAL) {
        this.show_quantity_of_times_a_day = true;
        this.show_quantity = true;
        this.show_all_frequency = false;
        this.medicine_amount_of_times_id = 1;
        this.type_medicine_amount_of_times_id = "DAY";
        this.show_shifts = false;

        let amountOfTimes = [];

        for (let item of medicineAmountOfTimes) {
          if (item.type == "DAY") {
            amountOfTimes.push(item);
          }
        }

        this.amountOfTimes = amountOfTimes;
      }

      if (value == SEMANAL) {
        this.show_weekly = true;
      }

      this.medicine_frequency_abbreviation =
        medicine_frequency_abbreviation[value];
    },

    handleChangeDuration(value) {
      const CONTINUO = "CONTINUO";
      const ATE_A_DATA = "ATE_A_DATA";
      const DURANTE_UM_PERIODO = "DURANTE_UM_PERIODO";

      if (value == CONTINUO) {
        this.show_start_date = false;
      } else {
        this.show_start_date = true;
      }

      if (value == ATE_A_DATA) {
        this.show_end_date = true;
      } else {
        this.show_end_date = false;
      }

      if (value == DURANTE_UM_PERIODO) {
        this.show_duration_time = true;
      } else {
        this.show_duration_time = false;
      }
    },

    handleChangeMlOrDrops(value) {
      let { tmp_quantity, drops_quantity, ui_quantity } = this;

      if (value == "ML") {
        this.quantity = tmp_quantity;
      }

      if (value == "GOTAS") {
        this.quantity = drops_quantity;
      }

      if (value == "UI") {
        this.quantity = ui_quantity;
      }
    },

    handleChangeMlOrDropsMorningQuantity(value) {
      let {
        tmp_morning_quantity,
        drops_morning_quantity,
        ui_morning_quantity,
      } = this;

      if (value == "ML") {
        this.morning_quantity = tmp_morning_quantity;
      }

      if (value == "GOTAS") {
        this.morning_quantity = drops_morning_quantity;
      }

      if (value == "UI") {
        this.morning_quantity = ui_morning_quantity;
      }
    },

    handleChangeMlOrDropsAfternoonQuantity(value) {
      let {
        tmp_afternoon_quantity,
        drops_afternoon_quantity,
        ui_afternoon_quantity,
      } = this;

      if (value == "ML") {
        this.afternoon_quantity = tmp_afternoon_quantity;
      }

      if (value == "GOTAS") {
        this.afternoon_quantity = drops_afternoon_quantity;
      }

      if (value == "UI") {
        this.afternoon_quantity = ui_afternoon_quantity;
      }
    },

    handleChangeMlOrDropsNightQuantity(value) {
      let { tmp_night_quantity, drops_night_quantity, ui_night_quantity } =
        this;

      if (value == "ML") {
        this.night_quantity = tmp_night_quantity;
      }

      if (value == "GOTAS") {
        this.night_quantity = drops_night_quantity;
      }

      if (value == "UI") {
        this.night_quantity = ui_night_quantity;
      }
    },

    handleChangeMlOrDropsDawnQuantity(value) {
      let { tmp_dawn_quantity, drops_dawn_quantity, ui_dawn_quantity } = this;

      if (value == "ML") {
        this.dawn_quantity = tmp_dawn_quantity;
      }

      if (value == "GOTAS") {
        this.dawn_quantity = drops_dawn_quantity;
      }

      if (value == "UI") {
        this.dawn_quantity = ui_dawn_quantity;
      }
    },

    handleChangeMlOrDropsshift_5Quantity(value) {
      let {
        tmp_shift_5_quantity,
        drops_shift_5_quantity,
        ui_shift_5_quantity,
      } = this;

      if (value == "ML") {
        this.shift_5_quantity = tmp_shift_5_quantity;
      }

      if (value == "GOTAS") {
        this.shift_5_quantity = drops_shift_5_quantity;
      }

      if (value == "UI") {
        this.shift_5_quantity = ui_shift_5_quantity;
      }
    },

    handleChangeMlOrDropsshift_6Quantity(value) {
      let {
        tmp_shift_6_quantity,
        drops_shift_6_quantity,
        ui_shift_6_quantity,
      } = this;

      if (value == "ML") {
        this.shift_6_quantity = tmp_shift_6_quantity;
      }

      if (value == "GOTAS") {
        this.shift_6_quantity = drops_shift_6_quantity;
      }

      if (value == "UI") {
        this.shift_6_quantity = ui_shift_6_quantity;
      }
    },

    handleChangeMlOrDropsshift_7Quantity(value) {
      let {
        tmp_shift_7_quantity,
        drops_shift_7_quantity,
        ui_shift_7_quantity,
      } = this;

      if (value == "ML") {
        this.shift_7_quantity = tmp_shift_7_quantity;
      }

      if (value == "GOTAS") {
        this.shift_7_quantity = drops_shift_7_quantity;
      }

      if (value == "UI") {
        this.shift_7_quantity = ui_shift_7_quantity;
      }
    },

    handleChangeMlOrDropsshift_8Quantity(value) {
      let {
        tmp_shift_8_quantity,
        drops_shift_8_quantity,
        ui_shift_8_quantity,
      } = this;

      if (value == "ML") {
        this.shift_8_quantity = tmp_shift_8_quantity;
      }

      if (value == "GOTAS") {
        this.shift_8_quantity = drops_shift_8_quantity;
      }

      if (value == "UI") {
        this.shift_8_quantity = ui_shift_8_quantity;
      }
    },

    handleMlOrDrops() {
      let {
        unit_of_measurement_value,
        ui_morning_quantity,
        drops_morning_quantity,
        ui_afternoon_quantity,
        drops_afternoon_quantity,
        ui_night_quantity,
        drops_night_quantity,
        ui_dawn_quantity,
        drops_dawn_quantity,
        ui_shift_5_quantity,
        drops_shift_5_quantity,
        ui_shift_6_quantity,
        drops_shift_6_quantity,
        ui_shift_7_quantity,
        drops_shift_7_quantity,
        ui_shift_8_quantity,
        drops_shift_8_quantity,
        ui_quantity,
        drops_quantity,
      } = this;

      if (
        unit_of_measurement_value == "ML" ||
        unit_of_measurement_value == "UI"
      ) {
        if (drops_morning_quantity || ui_morning_quantity) {
          if (ui_morning_quantity) {
            this.ml_or_drops_morning_quantity = "UI";
            this.morning_quantity = ui_morning_quantity;
            this.handleChangeMlOrDropsMorningQuantity("UI");
          }
          if (drops_morning_quantity) {
            this.ml_or_drops_morning_quantity = "GOTAS";
            this.morning_quantity = drops_morning_quantity;
            this.handleChangeMlOrDropsMorningQuantity("GOTAS");
          }
        } else {
          this.ml_or_drops_morning_quantity = unit_of_measurement_value;
          this.handleChangeMlOrDropsMorningQuantity("ML");
        }

        if (drops_afternoon_quantity || ui_afternoon_quantity) {
          if (ui_afternoon_quantity) {
            this.ml_or_drops_afternoon_quantity = "UI";
            this.afternoon_quantity = ui_afternoon_quantity;
            this.handleChangeMlOrDropsAfternoonQuantity("UI");
          }
          if (drops_afternoon_quantity) {
            this.ml_or_drops_afternoon_quantity = "GOTAS";
            this.afternoon_quantity = drops_afternoon_quantity;
            this.handleChangeMlOrDropsAfternoonQuantity("GOTAS");
          }
        } else {
          this.ml_or_drops_afternoon_quantity = unit_of_measurement_value;
          this.handleChangeMlOrDropsAfternoonQuantity("ML");
        }

        if (drops_night_quantity || ui_night_quantity) {
          if (ui_night_quantity) {
            this.ml_or_drops_night_quantity = "UI";
            this.night_quantity = ui_night_quantity;
            this.handleChangeMlOrDropsNightQuantity("UI");
          }
          if (drops_night_quantity) {
            this.ml_or_drops_night_quantity = "GOTAS";
            this.night_quantity = drops_night_quantity;
            this.handleChangeMlOrDropsNightQuantity("GOTAS");
          }
        } else {
          this.ml_or_drops_night_quantity = unit_of_measurement_value;
          this.handleChangeMlOrDropsNightQuantity("ML");
        }

        if (drops_dawn_quantity || ui_dawn_quantity) {
          if (ui_dawn_quantity) {
            this.ml_or_drops_dawn_quantity = "UI";
            this.dawn_quantity = ui_dawn_quantity;
            this.handleChangeMlOrDropsDawnQuantity("UI");
          }
          if (drops_dawn_quantity) {
            this.ml_or_drops_dawn_quantity = "GOTAS";
            this.dawn_quantity = drops_dawn_quantity;
            this.handleChangeMlOrDropsDawnQuantity("GOTAS");
          }
        } else {
          this.ml_or_drops_dawn_quantity = unit_of_measurement_value;
          this.handleChangeMlOrDropsDawnQuantity("ML");
        }

        if (drops_shift_5_quantity || ui_shift_5_quantity) {
          if (ui_shift_5_quantity) {
            this.ml_or_drops_shift_5_quantity = "UI";
            this.shift_5_quantity = ui_shift_5_quantity;
            this.handleChangeMlOrDropsshift_5Quantity("UI");
          }
          if (drops_shift_5_quantity) {
            this.ml_or_drops_shift_5_quantity = "GOTAS";
            this.shift_5_quantity = drops_shift_5_quantity;
            this.handleChangeMlOrDropsshift_5Quantity("GOTAS");
          }
        } else {
          this.ml_or_drops_shift_5_quantity = unit_of_measurement_value;
          this.handleChangeMlOrDropsshift_5Quantity("ML");
        }

        if (drops_shift_6_quantity || ui_shift_6_quantity) {
          if (ui_shift_6_quantity) {
            this.ml_or_drops_shift_6_quantity = "UI";
            this.shift_6_quantity = ui_shift_6_quantity;
            this.handleChangeMlOrDropsshift_6Quantity("UI");
          }
          if (drops_shift_6_quantity) {
            this.ml_or_drops_shift_6_quantity = "GOTAS";
            this.shift_6_quantity = drops_shift_6_quantity;
            this.handleChangeMlOrDropsshift_6Quantity("GOTAS");
          }
        } else {
          this.ml_or_drops_shift_6_quantity = unit_of_measurement_value;
          this.handleChangeMlOrDropsshift_6Quantity("ML");
        }

        if (drops_shift_7_quantity || ui_shift_7_quantity) {
          if (ui_shift_7_quantity) {
            this.ml_or_drops_shift_7_quantity = "UI";
            this.shift_7_quantity = ui_shift_7_quantity;
            this.handleChangeMlOrDropsshift_7Quantity("UI");
          }
          if (drops_shift_7_quantity) {
            this.ml_or_drops_shift_7_quantity = "GOTAS";
            this.shift_7_quantity = drops_shift_7_quantity;
            this.handleChangeMlOrDropsshift_7Quantity("GOTAS");
          }
        } else {
          this.ml_or_drops_shift_7_quantity = unit_of_measurement_value;
          this.handleChangeMlOrDropsshift_7Quantity("ML");
        }

        if (drops_shift_8_quantity || ui_shift_8_quantity) {
          if (ui_shift_8_quantity) {
            this.ml_or_drops_shift_8_quantity = "UI";
            this.shift_8_quantity = ui_shift_8_quantity;
            this.handleChangeMlOrDropsshift_8Quantity("UI");
          }
          if (drops_shift_8_quantity) {
            this.ml_or_drops_shift_8_quantity = "GOTAS";
            this.shift_8_quantity = drops_shift_8_quantity;
            this.handleChangeMlOrDropsshift_8Quantity("GOTAS");
          }
        } else {
          this.ml_or_drops_shift_8_quantity = unit_of_measurement_value;
          this.handleChangeMlOrDropsshift_8Quantity("ML");
        }

        if (drops_quantity || ui_quantity) {
          if (ui_quantity) {
            this.ml_or_drops = "UI";
            this.handleChangeMlOrDrops("UI");
          }
          if (drops_quantity) {
            this.ml_or_drops = "GOTAS";
            this.handleChangeMlOrDrops("GOTAS");
          }
        } else {
          this.handleChangeMlOrDrops("ML");
          this.ml_or_drops = unit_of_measurement_value;
        }
      } else {
        this.ml_or_drops = null;
      }
    },

    async retrieve() {
      this.loading = true;

      let { user } = userData();

      this.rest_home_id = user.rest_home_id;
      this.user_id = user.id;

      const { prescription_medicine } = this;

      this.resident_id = prescription_medicine.resident_id;

      if (this.errors.length == 0) await this.getUnitOfMeasurements();
      if (this.errors.length == 0) await this.getRouteOfAdministration();
      if (this.errors.length == 0) await this.getMedicineAmountOfTimes();
      if (this.errors.length > 0) return;

      let {
        id,
        medicine_name,
        medicine_active_ingredient,
        unit_of_measurement_id,
        unit_of_measurement_name,
        unit_of_measurement_abbreviation,
        unit_of_measurement_value,
        route_of_administration_id,
        frequency,
        medicine_amount_of_times_id,
        every,
        morning,
        morning_quantity,
        ui_morning_quantity,
        drops_morning_quantity,
        afternoon,
        afternoon_quantity,
        ui_afternoon_quantity,
        drops_afternoon_quantity,
        night,
        night_quantity,
        ui_night_quantity,
        drops_night_quantity,
        dawn,
        dawn_quantity,
        ui_dawn_quantity,
        drops_dawn_quantity,
        shift_5,
        shift_5_quantity,
        ui_shift_5_quantity,
        drops_shift_5_quantity,
        shift_6,
        shift_6_quantity,
        ui_shift_6_quantity,
        drops_shift_6_quantity,
        shift_7,
        shift_7_quantity,
        ui_shift_7_quantity,
        drops_shift_7_quantity,
        shift_8,
        shift_8_quantity,
        ui_shift_8_quantity,
        drops_shift_8_quantity,
        dom,
        seg,
        ter,
        qua,
        qui,
        sex,
        sab,
        quantity,
        ui_quantity,
        drops_quantity,
        start_date,
        duration,
        duration_time,
        end_date,
        instruction,
        repeat_after_type,
        repeat_dosage,
        repeat_after,
        how_many_times,
      } = prescription_medicine;

      this.handleChangeFrequency(frequency);
      this.handleChangeMedicineAmountOfTimesId(medicine_amount_of_times_id);
      this.handleChangeDuration(duration);

      this.id = id;
      this.name = medicine_name;
      this.active_ingredient = medicine_active_ingredient;
      this.unit_of_measurement_id = unit_of_measurement_id;
      this.unit_of_measurement_value = unit_of_measurement_value;
      this.unit_of_measurement_name = unit_of_measurement_name;
      this.unit_of_measurement_abbreviation = unit_of_measurement_abbreviation;
      this.route_of_administration_id = route_of_administration_id;
      this.frequency = frequency;
      this.medicine_amount_of_times_id = medicine_amount_of_times_id;
      this.morning = morning;
      this.morning_quantity = morning_quantity;
      this.tmp_morning_quantity = morning_quantity;
      this.ui_morning_quantity = ui_morning_quantity;
      this.drops_morning_quantity = drops_morning_quantity;
      this.afternoon = afternoon;
      this.afternoon_quantity = afternoon_quantity;
      this.tmp_afternoon_quantity = afternoon_quantity;
      this.ui_afternoon_quantity = ui_afternoon_quantity;
      this.drops_afternoon_quantity = drops_afternoon_quantity;
      this.night = night;
      this.night_quantity = night_quantity;
      this.tmp_night_quantity = night_quantity;
      this.ui_night_quantity = ui_night_quantity;
      this.drops_night_quantity = drops_night_quantity;
      this.dawn = dawn;
      this.dawn_quantity = dawn_quantity;
      this.tmp_dawn_quantity = dawn_quantity;
      this.ui_dawn_quantity = ui_dawn_quantity;
      this.drops_dawn_quantity = drops_dawn_quantity;
      this.shift_5 = shift_5;
      this.shift_5_quantity = shift_5_quantity;
      this.tmp_shift_5_quantity = shift_5_quantity;
      this.ui_shift_5_quantity = ui_shift_5_quantity;
      this.drops_shift_5_quantity = drops_shift_5_quantity;
      this.shift_6 = shift_6;
      this.shift_6_quantity = shift_6_quantity;
      this.tmp_shift_6_quantity = shift_6_quantity;
      this.ui_shift_6_quantity = ui_shift_6_quantity;
      this.drops_shift_6_quantity = drops_shift_6_quantity;
      this.shift_7 = shift_7;
      this.shift_7_quantity = shift_7_quantity;
      this.tmp_shift_7_quantity = shift_7_quantity;
      this.ui_shift_7_quantity = ui_shift_7_quantity;
      this.drops_shift_7_quantity = drops_shift_7_quantity;
      this.shift_8 = shift_8;
      this.shift_8_quantity = shift_8_quantity;
      this.tmp_shift_8_quantity = shift_8_quantity;
      this.ui_shift_8_quantity = ui_shift_8_quantity;
      this.drops_shift_8_quantity = drops_shift_8_quantity;
      this.every = every;
      this.DOM = dom;
      this.SEG = seg;
      this.TER = ter;
      this.QUA = qua;
      this.QUI = qui;
      this.SEX = sex;
      this.SAB = sab;
      this.quantity = quantity;
      this.tmp_quantity = quantity;
      this.ui_quantity = ui_quantity;
      this.drops_quantity = drops_quantity;
      this.start_date = formatDateToUs(start_date);
      this.duration = duration;
      this.duration_time = duration_time;
      this.end_date = formatDateToUs(end_date);
      this.instruction = instruction;
      this.repeat_after_type = repeat_after_type;
      this.repeat_dosage = repeat_dosage;
      this.repeat_after = repeat_after;
      this.how_many_times = how_many_times;

      this.handleMlOrDrops();

      this.loading = false;
    },

    async getUnitOfMeasurements() {
      try {
        const response = await api.get("/rest-home/unit-of-measurement/all");

        const { error, errors, unit_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.unitOfMeasurements = unit_of_measurement;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getRouteOfAdministration() {
      try {
        const response = await api.get("/admin/care/routes-of-administration");

        const { error, errors, routes_of_administration } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.routeOfAdministration = routes_of_administration;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getMedicineAmountOfTimes() {
      try {
        const response = await api.get("/admin/medicine-amount-of-times");

        const { error, errors, medicine_amount_of_times } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.medicineAmountOfTimes = medicine_amount_of_times;
          this.amountOfTimes = medicine_amount_of_times;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      try {
        this.loadingUpdate = true;

        let {
          id,
          rest_home_id,
          user_id,
          resident_id,
          unit_of_measurement_id, //VALOR UNIDADE DE MEDIDA
          unit_of_measurement_value, //VALOR UNIDADE DE MEDIDA
          route_of_administration_id, //VIA DE ADMINISTRAÇÃO
          frequency, //FREQUÊNCIA
          medicine_amount_of_times_id, //QUANTIDADE DIÁRIA
          type_medicine_amount_of_times_id, //TIPO QUANTIDADE DIÁRIA
          every, //A CADA,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning, //MANHÃ
          morning_quantity,
          afternoon, //TARDE
          afternoon_quantity,
          night, //NOITE
          night_quantity,
          dawn, //MADRUGADA
          dawn_quantity,
          shift_5, //5º
          shift_5_quantity,
          shift_6, //6º
          shift_6_quantity,
          shift_7, //7º
          shift_7_quantity,
          shift_8, //8º
          shift_8_quantity,
          quantity, //QUANTIDADE
          start_date, //DATA DE INÍCIO
          duration, //DURAÇÃO
          duration_time, //TEMPO DE DURAÇÃO
          end_date, //DATA DE TÉRMINO
          instruction, //INSTRUÇÃO
          ml_or_drops,
          ml_or_drops_morning_quantity,
          ml_or_drops_afternoon_quantity,
          ml_or_drops_night_quantity,
          ml_or_drops_dawn_quantity,
          ml_or_drops_shift_5_quantity,
          ml_or_drops_shift_6_quantity,
          ml_or_drops_shift_7_quantity,
          ml_or_drops_shift_8_quantity,
          repeat_after_type,
          repeat_dosage,
          repeat_after,
          how_many_times,
          init,
        } = this;

        let params = {
          id,
          rest_home_id,
          user_id,
          resident_id,
          unit_of_measurement_id,
          unit_of_measurement_value,
          route_of_administration_id,
          frequency,
          medicine_amount_of_times_id,
          type_medicine_amount_of_times_id,
          every,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning,
          morning_quantity,
          afternoon,
          afternoon_quantity,
          night,
          night_quantity,
          dawn,
          dawn_quantity,
          shift_5,
          shift_5_quantity,
          shift_6,
          shift_6_quantity,
          shift_7,
          shift_7_quantity,
          shift_8,
          shift_8_quantity,
          quantity,
          start_date,
          duration,
          duration_time,
          end_date,
          instruction,
          ml_or_drops,
          ml_or_drops_morning_quantity,
          ml_or_drops_afternoon_quantity,
          ml_or_drops_night_quantity,
          ml_or_drops_dawn_quantity,
          ml_or_drops_shift_5_quantity,
          ml_or_drops_shift_6_quantity,
          ml_or_drops_shift_7_quantity,
          ml_or_drops_shift_8_quantity,
          repeat_after_type,
          repeat_dosage,
          repeat_after,
          how_many_times,
          init,
        };

        const response = await api.put(
          "/rest-home/prescription-medicine",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("update", "paginate");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateInstruction() {
      try {
        this.loadingUpdate = true;

        let { id, instruction } = this;

        let params = { id, instruction };

        const response = await api.put(
          "/rest-home/prescription-medicine-instruction",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("update", "paginate");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async isValidToUpdate() {
      try {
        this.loadingUpdate = true;

        let { id, resident_id } = this;

        let params = { id, resident_id };

        const response = await api.get("/rest-home/prescription-medicine", {
          params,
        });

        const { error, errors, dates } = response.data;

        if (!error) {
          this.errors = [];
          this.datesCheck = [];
          this.edit = "MEDICINE";
        } else {
          this.errors = errors;
          this.datesCheck = dates;
        }

        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleCheckDate(date) {
      let route = this.$router.resolve({
        name: "resident",
        query: { tab: "check", nav: "check", date },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
